import Vue from 'vue';
import * as orderStatuses from '@/constants/orderStatuses';
import * as roles from '@/constants/roles';

export default {
    check(user, role) {
        if (Array.isArray(user.roles)) {
            return user.roles.includes(role);
        }
        return false;
    },

    checkMany(user, roles) {
        if (Array.isArray(user.roles) && Array.isArray(roles)) {
            return user.roles.some(role => roles.includes(role));
        }
        return false;
    },

    // Check user role against an array of RouteRecords
    areRoutesAuthorized(user, records) {
        if (!(Array.isArray(user.roles) && Array.isArray(records))) {
            return false; // parameters are not arrays
        }

        // Check if every record that has 'authorize' passes a role check
        return records.every(record => {
            if (!record.meta.authorize) {
                return true; // no authorize check
            }
            if (!Array.isArray(record.meta.authorize)) {
                return false; // unexpected type
            }
            // Check if user's roles matches any authorized roles
            return this.checkMany(user, record.meta.authorize);
        });
    },

    // Get the home relative route aassociated to the role
    getRoleHome(user) {
        // HACK: Assuming user has valid roles
        switch (user.roles[0]) {
            case roles.OPERATOR:
                return roles.OPERATOR_HOME;
            case roles.RESTAURATEUR:
                return roles.RESTAURATEUR_HOME;
            default:
                Vue.$log &&
                    Vue.$log.warn(
                        `roleUtil processed user without valid role. ID: ${user.id}`
                    );
                return '/';
        }
    },

    // Single source of logic to check when restaurateur can edit/delete order
    canRestaurateurEditOrder(order) {
        return order.status == orderStatuses.NEW;
    },
    canRestaurateurDeleteOrder(order) {
        return order.status == orderStatuses.NEW;
    },
    canOrderBeCancelled(order) {
        return order.status != orderStatuses.COMPLETED;
    }
};
